import {
  Component, EventEmitter, Input, Output, SimpleChanges, ViewEncapsulation
} from '@angular/core';

import { IrisButtonTypeAttributeOptions, IrisButtonTarget } from '@sondermind/iris/shared';

export enum IrisButtonTypes {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  DANGER = 'danger',
  DANGER_SECONDARY = 'danger-secondary'
}

export enum IrisButtonIconPositions {
  LEFT = 'left',
  RIGHT = 'right'
}

@Component({
  selector: 'iris-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})

export class IrisButtonComponent {
  private irisButtonTypes = IrisButtonTypes;
  /**
   * @deprecated
   * Please use the buttonType attribute instead of the type attribute.
   */
  @Input() type: IrisButtonTypes = this.irisButtonTypes.PRIMARY;
  @Input() buttonType!: IrisButtonTypes;
  @Input() typeAttribute: IrisButtonTypeAttributeOptions = IrisButtonTypeAttributeOptions.SUBMIT;
  @Input() disabled: boolean | undefined;
  @Input() linkHref: string | undefined;
  @Input() iconPosition: IrisButtonIconPositions | undefined;
  @Input() ksDocsOnlyButtonText: string | undefined;
  @Input() target: IrisButtonTarget | undefined;
  @Output() click = new EventEmitter();

  buttonClasses!: string;
  irisButtonIconPosition = IrisButtonIconPositions;

  onClick(event: Event): void {
    event.stopImmediatePropagation();
    if (!this.disabled) {
      this.click.emit(event);
    }
  }

  ngOnInit(): void {
    if (this.buttonType) {
      this.buttonClasses = `iris-button iris-button--${this.buttonType}`;
    } else {
      this.buttonClasses = `iris-button iris-button--${this.type}`;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['buttonType']) {
      this.buttonClasses = `iris-button iris-button--${this.buttonType}`;
    }
  }
}
